import { render, staticRenderFns } from "./create_rubric_dropdown.vue?vue&type=template&id=1b57abfd&scoped=true&"
import script from "./create_rubric_dropdown.vue?vue&type=script&lang=js&"
export * from "./create_rubric_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./create_rubric_dropdown.vue?vue&type=style&index=0&id=1b57abfd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b57abfd",
  null
  
)

export default component.exports